<template>
  <div
    :style="{ backgroundImage: 'url(' + bg + ')', backgroundPosition: 'center' }"
  >
    <v-container grid-list-lg>
      <v-layout 
        class="mb-3"
        justify-space-between
        wrap
      >
        <!--<v-flex md4>
          <v-btn
            block
            large
            outline
            color="secondary"
            @click="showMore"
          >
            <v-icon left>import_contacts</v-icon>
            <span>More Programs</span>
          </v-btn>
        </v-flex>
        <v-flex md4>
          <v-text-field
            label="Search Modules"
            prepend-icon="search"
            v-model="search"
            solo
          >
            
          </v-text-field>
        </v-flex>-->
      </v-layout>

      <v-layout class="mb-3">
        <v-flex>
          <strong><span class="primary--text">{{ completedModules }}</span>/{{ totalModules }} Videos watched</strong>
          as of {{ dateToday }}
        </v-flex>
      </v-layout>

      
        <v-data-iterator
          content-tag="v-layout"
          row
          wrap
          :items="modules"
          :rows-per-page-items="rowsPerPageItems"
          :pagination.sync="pagination"
        >
          <v-flex
            slot="item"
            slot-scope="props"
            xs12
            sm6
            md4
            lg4
          >
            <v-card
              hover
              @click.native="handleClick(props.item)"
            >
              <v-card-media
                :src="props.item.image"
                height="200"
              >
                <v-container fill-height>
                  <v-layout align-end>
                    <v-spacer></v-spacer>
                    <v-flex text-md-right>
                      <div v-if="isAlreadyWatched(props.item)">
                        <v-chip color="orange" text-color="white">
                          <strong>Completed</strong>
                          <v-icon right>star</v-icon>
                        </v-chip>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-media>

              <v-list two-line>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <strong>{{ props.item.title }}</strong>
                    </v-list-tile-title>
                    <!-- <v-list-tile-sub-title>
                      {{ props.item.description }}
                    </v-list-tile-sub-title> -->
                    <v-list-tile-sub-title>
                      <em>by {{ props.item.author }}</em>
                    </v-list-tile-sub-title>
                     <v-list-tile-sub-title>
                      <span class="codes_style">{{ props.item.codes }}</span>
                     </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>

              <v-card-text>
                <!--<strong>CPD Points </strong>
                <v-avatar color="primary">
                  <span class="white--text title">{{ props.item.cpd_points }}</span>
                </v-avatar>-->
                <!--<v-btn
                  v-if="!checkIfNotInWatchList(props.item)"
                  @click.stop="onClickAddWatchList(props.item)"
                >Add to watchlist</v-btn>-->
              </v-card-text>
            </v-card>
          </v-flex>
        </v-data-iterator>

    </v-container>
  </div>
</template>

<script>
import moment from 'moment'

// import { getUser } from '@/utils/token'

export default {
  computed: {
    dateToday () {
      return moment().format('LL')
    },
    totalModules () {
      return this.modules.length || 0
    },
    completedModules () {
      return this.user.user_assessment.filter(i => i.earned > 0).length || 0
    }
  },
  data () {
    return {
      bg: require('@/assets/bg/water_6.png'),
      search: '',
      rowsPerPageItems: [6, 12, 18],
      pagination: {
        rowsPerPage: 5
      },
      latestModules: []
    }
  },
  methods: {
    handleClick (module) {
      this.$router.push('/module/' + module.id)
      this.addToWatchlist(module)
    },
    showMore () {
      alert('show more programs')
    },
    onClickAddWatchList (item) {
      this.addToWatchlist(item)
    },
    checkIfNotInWatchList (item) {
      return this.watchlist.some(i => i.module_id === item.id)
    },
    isAlreadyWatched (item) {
      if (this.user.user_assessment) {
        let watched = this.user.user_assessment.some((u) => Number(u.module_id) === Number(item.id))
        return watched
      }
    }
  },
  props: {
    user: {
      type: Object,
      default: () => {}
    },
    modules: {
      default () {
        return []
      }
    },
    watchlist: {
      default () {
        return []
      }
    },
    addToWatchlist: {
      type: Function
    }
  },
  watch: {
    modules (v) {
      this.latestModules = v
    }
  }
}
</script>
<style>
.codes_style {
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/latestModules.vue